/**
 * Единая точка чтения конфига.
 *
 * Приоритет: runtime (на вебе — window.__env, подставляется nginx-энтрипоинтом
 * в собранном образе) -> build-time (у vite — import.meta.env). Благодаря
 * этому один образ переезжает между dev/qa/prod без пересборки. Сами
 * источники приносит площадка через platformEnv — модуль про window не знает
 * (docs/MOBILE.md, шаг 2).
 */
import { platformEnv } from '@/shared/platform/env'

function env(key: string, fallback = ''): string {
  const runtime = platformEnv.runtime(key)
  if (runtime && !runtime.startsWith('$')) return runtime

  // || , а не ?? : пустая строка здесь означает «значение не задано», как и
  // undefined. Иначе VITE_API_URL= (пустой) дал бы пустой apiUrl вместо
  // дефолта — а compose всегда прокидывает весь набор VITE_*, в том числе
  // потенциально пустых. Runtime-ветка выше проверяет непустоту точно так же.
  const buildTime = platformEnv.buildTime(key)
  return buildTime || fallback
}

export const config = {
  // Имя проекта: заголовок вкладки и шапка. Приходит из ENV, чтобы имя
  // не было вшито в код — см. VITE_APP_NAME в .env.
  appName: env('VITE_APP_NAME', 'app'),
  apiUrl: env('VITE_API_URL', '/api/v1'),
  reverb: {
    key: env('VITE_REVERB_APP_KEY'),
    host: env('VITE_REVERB_HOST', platformEnv.hostname()),
    port: Number(env('VITE_REVERB_PORT', '80')),
    scheme: env('VITE_REVERB_SCHEME', 'ws'),
  },
  sentry: {
    // Пустой DSN ⇒ SDK не инициализируется (так на local).
    dsn: env('VITE_SENTRY_DSN'),
    environment: env('VITE_SENTRY_ENV', 'local'),
    release: env('VITE_SENTRY_RELEASE'),
    // Строкой в env, поэтому приводим и подстраховываемся от мусора:
    // NaN в tracesSampleRate тихо отключил бы трассировку.
    tracesSampleRate: Number.parseFloat(env('VITE_SENTRY_TRACES_SAMPLE_RATE', '0')) || 0,
  },
} as const
